import { render } from "./RoleIndex.vue?vue&type=template&id=16e23480"
import script from "./RoleIndex.vue?vue&type=script&lang=js"
export * from "./RoleIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__